import * as React from 'react';
import { MortgageLandingContainer } from '../../containers/MortgageLandingContainer';
import { SeoContainer } from '../../containers/seo_container';
import { Specialists } from '../../containers/specialists/specialists';
import { VacanciesContainer } from '../../containers/vacancies/vacancies';
import { VerticalPromo } from '../../containers/vertical_promo/vertical_promo';
import { CommercialPromo } from '../../containers/commercial_promo/commercial_promo';
import { NewBuildingsServices } from '../../containers/new_buildings_service/new_buildings_services';
import { MagazineContainer } from '../../containers/magazine/magazine';
import { SearchBlockContainer } from '../SearchBlockContainer/SearchBlockContainer';
import { SaleServices } from '../../containers/sale_services/sale_services';
import { PopularList } from '../../containers/popular_list/popular_list';
import { JKPopularList } from '../../containers/popular_jk/popular_jk';
import { NewBuildingCaption } from '../../containers/new_building_caption/new_building_caption';
import { SalesLinksContainer } from '../../containers/SalesLinksContainer';
import { GeoSwitcherWrapperContainer } from '../../containers/GeoSwitcherContainer';
import { RecommendationsContainer } from '../../containers/RecommendationsContainer';
import { useSelector } from 'react-redux';
import { selectIsFetching } from '../../selectors/mainpage/selectIsFetching';
import { selectSpecialTabActive } from '../../hooks/selectors/specialTabs';
import { ESpecialTabs } from '../../constants/specialTabs';
import { selectPageSection } from '../../selectors/pageSection';
import { selectTop3 } from '../../selectors/mainpage/selectTop3';
import { selectPopularJks } from '../../selectors/mainpage/selectPopularJks';
import { TwoColumnContainer } from '../../components/two_column_container/two_column_container';
import { UsefulLinksContainer } from '../UsefulLinksContainer';
import { SeoCrossLinksContainer } from '../SeoCrossLinksContainer';
import { experimentToggle } from '../../components/experimentToggle';
import { useRemovePopularExperiment } from '../../hooks';
import { SNR_DESKTOP_SR135_REMOVE_POPULAR } from '../../constants/experiments';
import { SpecialistsContainer } from '../SpecialistsContainer';
import { ContentLayout } from '../../components/ContentLayout';

export const HomeContainer: React.FC = () => {
  const isFetching = useSelector(selectIsFetching);
  const isMortgageTabActive = useSelector(selectSpecialTabActive) === ESpecialTabs.Mortgage;
  const section = useSelector(selectPageSection);
  const top3 = useSelector(selectTop3);
  const popularJks = useSelector(selectPopularJks);
  const { isEnabled, experimentGroup } = useRemovePopularExperiment();

  const popularPresented = top3.length > 0 || popularJks.length > 0;

  const servicesBlock = React.useMemo(() => {
    switch (section) {
      case 'daily-rent':
      case 'commercial':
      case 'sale':
      case 'rent':
        return <SaleServices />;
      case 'new-buildings':
        return <NewBuildingsServices />;
      case 'index':
      default:
        return null;
    }
  }, [section]);

  const isUsefulLinksVisible = ['index', 'sale', 'rent', 'daily-rent'].includes(section);

  const promoBlock = React.useMemo(() => {
    switch (section) {
      case 'new-buildings':
        return <VerticalPromo />;
      case 'commercial':
        return <CommercialPromo />;
      default:
        return null;
    }
  }, [section]);

  const popularBlock = React.useMemo(() => {
    if (section === 'new-buildings') {
      return <JKPopularList services={servicesBlock} />;
    } else {
      return <PopularList showLinkToAll={section !== 'index'} services={servicesBlock} />;
    }
  }, [section, servicesBlock]);

  const isIndexSection = section === 'index';

  if (isFetching) {
    return null;
  }

  if (isMortgageTabActive) {
    return (
      <div>
        <GeoSwitcherWrapperContainer />
        <NewBuildingCaption section={section} />
        <SearchBlockContainer />
        <MortgageLandingContainer />
      </div>
    );
  } else {
    return (
      <div>
        <GeoSwitcherWrapperContainer />
        <NewBuildingCaption section={section} />
        <SearchBlockContainer />
        <RecommendationsContainer />

        {
          /**
           * @todo Удалить после завершения эксперимента
           * @description Данный функционал появился в задаче CD-253219, будет удалён в задаче CD-253242
           */
          experimentToggle(
            isEnabled,
            SNR_DESKTOP_SR135_REMOVE_POPULAR,
            experimentGroup,
            isUsefulLinksVisible && <UsefulLinksContainer />,
          )
        }

        <SalesLinksContainer section={section} />

        {promoBlock}

        {
          /**
           * @todo Удалить после завершения эксперимента
           * @description Данный функционал появился в задаче CD-253219, будет удалён в задаче CD-253242
           */
          experimentToggle(
            isEnabled,
            SNR_DESKTOP_SR135_REMOVE_POPULAR,
            experimentGroup,
            <TwoColumnContainer wideRow={section === 'commercial'} popularPresented={popularPresented}>
              {popularBlock}
              <Specialists section={section} popularPresented={popularPresented} />
            </TwoColumnContainer>,
            <ContentLayout
              specialistsBlock={<SpecialistsContainer section={section} />}
              usefulLinks={isUsefulLinksVisible && <UsefulLinksContainer />}
              saleServices={servicesBlock}
            />,
          )
        }

        {isIndexSection && (
          <>
            <MagazineContainer />
            <VacanciesContainer />
          </>
        )}

        <SeoContainer />
        {isIndexSection && <SeoCrossLinksContainer />}
      </div>
    );
  }
};
